import { css } from '@emotion/react';
import { Typography } from '@uniquegood/realworld-studio-design';
import { onMobile } from '@styles/responsive';
import companyLogo from '@/assets/images/company_logo.svg';

function Footer() {
  return (
    <footer css={mainContainer}>
      <img src={companyLogo} width="160" height="40" alt="리얼월드 스튜디오 로고" />
      <div css={infoContainer}>
        <div>
          <Typography
            type="caption"
            css={css`
              color: #8f8f8f;
            `}
          >
            주식회사 유니크굿컴퍼니
          </Typography>
          <Typography
            type="caption"
            css={css`
              color: #8f8f8f;
            `}
          >
            사업자등록번호 524-88-00746
          </Typography>
          <Typography
            type="caption"
            css={css`
              color: #8f8f8f;
            `}
          >
            전화번호 070-8706-1010
          </Typography>
          <Typography
            type="caption"
            css={css`
              color: #8f8f8f;
            `}
          >
            통신판매업신고번호 2018-서울성동-0760호
          </Typography>
        </div>
        <div>
          <div
            css={css`
              margin-bottom: 10px;
            `}
          >
            <Typography
              type="caption"
              css={css`
                color: #8f8f8f;
              `}
            >
              대표이사 이은영, 송인혁
            </Typography>
            <Typography
              type="caption"
              css={css`
                color: #8f8f8f;
              `}
            >
              서울특별시 성동구 연무장13길 8, 2층, 3층 (성수동2가, 메리히어)
            </Typography>
          </div>
          <a
            target="_blank"
            css={css`
              color: #8f8f8f;
              cursor: pointer;
              font-family: Pretendard;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 16px;
            `}
            href="https://uniquegoodcompany.notion.site/317906e557704f59ad24a2be8bb49612"
            rel="noreferrer"
          >
            이용약관
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

const mainContainer = css`
  width: 100%;
  height: 160px;
  display: flex;
  gap: 80px;
  background-color: #1a1a1a;
  color: #878a9d;
  padding: 40px 64px;

  ${onMobile} {
    flex-direction: column;
    height: auto;
    margin-top: 36px;
  }
`;

const infoContainer = css`
  display: flex;
  gap: 40px;
  font-size: 12px;
  word-break: keep-all;

  ${onMobile} {
    width: 100%;
    gap: 4px;
    justify-content: center;
    font-size: 8px;
  }

  span {
    text-align: center;
    word-break: keep-all;
  }
`;
